import type { JSX } from 'react';

import { UnderReviewError } from 'src/shared/error';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

import { Layout } from '../layout';

/**
 * All this component does is check whether the petition is under review. Only editors (staff & starter) are allowed to
 * view a petition that is under review. The check happens here because this is renders _after_ the user & petition data
 * have loaded but _before_ any of the page content is rendered.
 *
 * In theory we should be able to move this `UnderReviewError` check into the API layer (pageUserData/api) so that it
 * happens before any rendering. But this is tricky because:
 *  - The page is cached for guest users, with pageUserData determining the cache key.
 *  - For guests we don't fetch the petition in the pageUserData in order to save some time/data.
 *  - But we would need to fetch the petition's status if we wanted to put the `UnderReviewError` check there.
 */
export function DetailsStateWrapper(): JSX.Element {
	const {
		data: { petition },
	} = usePetitionDetailsPageData();
	const {
		data: { canEdit },
	} = usePetitionDetailsPageUserData();

	const underReview = petition.status === 'UNDER_REVIEW';
	if (underReview && !canEdit) {
		throw new UnderReviewError();
	}

	return <Layout />;
}
